import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
// import {
//     STORE_GETMESSAGES,
//     STORE_FILES_MSGATTACHMENT,
//     STORE_MESSAGE_RXFORM_MESSAGE,
//     AttachementData,
//     STORE_FILES_GETATTACHMENT,
// } from 'src/reducers/rxForm';
// import {
//     STORE_ERROR_MESSAGE,
//     STORE_ERROR_BAR,
//     // STORE_SUCCESS_MESSAGE,
//     // STORE_SUCCESS_BAR
// } from '../reducers/errors';
import {
    STORE_MESSAGE_SUPPORT_PAGE_MESSAGE,
    STORE_GETSUPPORTMESSAGES,
    STORE_FILES_SUPPORTMSGATTACHMENT,
    SupportAttachementData,
    STORE_FILES_GETSUPPORTATTACHMENT,
} from 'src/reducers/supportPage';
import { STORE_SUPPORT_STATUS, SupportRequestPayload } from 'src/reducers/supportRequest';
import { push } from 'react-router-redux';
import { STORE_LOADER } from 'src/reducers/landingPage';
// import { fromDate } from './completeOrderAction';

export const getMessage = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getOrderMessage?messageType=${getState().supportRequest.supporttype}&pid=${getState().supportRequest.ticketno}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {

        const getSupportMessage = response.data;
        dispatch({ type: STORE_GETSUPPORTMESSAGES, getSupportMessage } as AnyAction);

    }).catch(function (error: AxiosError) {
        // ==> console.error(error);
    });

};

export const messaging = (message: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_MESSAGE_SUPPORT_PAGE_MESSAGE, message } as AnyAction);
        return true;
    };
};

export const statusType = (statustype: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

        const sessionid = getState().user.userDetails.s || '';
        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}sendMessage`,
            data: {

                columns: {
                    messagetype: getState().supportRequest.supporttype,
                    message: 'Status has been changed',
                    caseno: getState().supportRequest.ticketno || '',
                    refmessageid: '',
                    status: statustype
                },
                attachments: []
            },
            headers: {
                sessionid: sessionid || ''
            },
        }).then(function (resp: AxiosResponse) {
            dispatch({ type: STORE_SUPPORT_STATUS, status: statustype } as AnyAction);
            getMessage(dispatch, getState);

            dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

            const message = '';
            dispatch({ type: STORE_MESSAGE_SUPPORT_PAGE_MESSAGE, message } as AnyAction);

        }).catch(function (error: AxiosError) {
            dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
            // ==> console.error(error.message);
        });
        // dispatch({ type: STORE_SUPPORT_STATUSTYPE, statustype } as AnyAction);
        return true;
    };
};

export const onFilesChange = (messageFiles: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        // const filterfile: Array<File> = [...getState().order.imagesNormal].concat(images);
        dispatch({ type: STORE_FILES_SUPPORTMSGATTACHMENT, messageFiles } as AnyAction);
        // messageFiles.length = 0;
    };
};

export const onFilesError = (error: Error, images: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        // ==> console.error(error.message);
        // images.length = 0;
    };
};

// export const sendSupportMessage = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const params = {

//         columns: {
//             messagetype: '',
//             message: '',
//             caseno: '',
//             refmessageid: '',
//         },
//         attachments: []
//     };

//     const sessionid = getState().user.userDetails.s || '';

//     params.columns.messagetype = '1';
//     params.columns.message = getState().supportPage.message || '';
//     params.columns.caseno = getState().user.userDetails.userName || '';
//     params.columns.refmessageid = '';

//     params.attachments = [];

//     await axios({
//         method: 'post',
//         url: `${getState().environment.API_URL}sendMessage`,
//         data: params,
//         headers: {
//             sessionid: sessionid || ''
//         },
//     }).then(async function (response: AxiosResponse) {

//         const message = '';
//         dispatch({ type: STORE_MESSAGE_SUPPORT_PAGE_MESSAGE, message } as AnyAction);
//         getMessage(dispatch, getState);

//     }).catch(function (error: AxiosError) {
//         // ==> console.error(error);
//     });
// };

export const sendSupportMessage = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    let input = getState().supportPage.message;
    const myAtt = getState().supportPage.messageFiles[0];
    // // ==> console.error(input, 'input1st');
    const attachments: Array<SupportAttachementData> = [];
    // // ==> console.error(myAtt, 'att');
    if (myAtt) {
        
        // attachmentFile(input, attachments);
        const sessionid = getState().user.userDetails.s || '';

        const formDataS = new FormData();
        formDataS.append('filetoattach', myAtt);
        input = getState().supportPage.message || `PRF - ${myAtt.name}`;
        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}attachMessageFileSupport`,
            data: formDataS,
            headers: {
                orderid: getState().supportRequest.ticketno,
                sourcetype: 'Message',
                sessionid: sessionid || '',
                dsorderid: ''
            },
        }).then(function (response: AxiosResponse) {
            // // ==> console.error(response, 'attresponce');
            getMessage(dispatch, getState);

            const message = '';
            dispatch({ type: STORE_MESSAGE_SUPPORT_PAGE_MESSAGE, message } as AnyAction);
            if (response.data.status) {
                attachments.push({
                    attachmentname: response.data.fileName,
                    attachfilename: `${response.data.location}/${response.data.fileName}`
                });
                const params = {

                    columns: {
                        messagetype: '',
                        message: '',
                        caseno: '',
                        refmessageid: '',
                        status: ''
                    },
                    attachments: attachments
                };

                // const sessionid = getState().user.userDetails.s || '';

                params.columns.messagetype = getState().supportRequest.supporttype;
                params.columns.message = input || '';
                params.columns.caseno = getState().supportRequest.ticketno || '';
                params.columns.refmessageid = '';
                params.columns.status = getState().supportRequest.status;

                params.attachments = attachments;

                axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}sendMessage`,
                    data: params,
                    headers: {
                        sessionid: sessionid || ''
                    },
                }).then(function (responseResult: AxiosResponse) {
                    // attachmentFile(dispatch, getState);
                    getMessage(dispatch, getState);

                    const messageFiles: Array<File> = [];
                    dispatch({ type: STORE_FILES_SUPPORTMSGATTACHMENT, messageFiles } as AnyAction);
                    const getSupportAttachmentData: Array<SupportAttachementData> = [];
                    dispatch({ type: STORE_FILES_GETSUPPORTATTACHMENT, getSupportAttachmentData } as AnyAction);
                }).catch(function (error: AxiosError) {

                    // ==> console.error(error.message);
                });
            }
        }).catch(function (error: AxiosError) {

            // ==> console.error(error.message);
        });
    } else {
        // sendMessage(input, attachments);
        const params = {

            columns: {
                messagetype: '',
                message: '',
                caseno: '',
                refmessageid: '',
                status: ''
            },
            attachments: attachments
        };

        const sessionid = getState().user.userDetails.s || '';

        params.columns.messagetype = getState().supportRequest.supporttype;
        params.columns.message = input || 'Status has been changed';
        params.columns.caseno = getState().supportRequest.ticketno || '';
        params.columns.refmessageid = '';
        params.columns.status = getState().supportRequest.status;

        params.attachments = attachments;

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}sendMessage`,
            data: params,
            headers: {
                sessionid: sessionid || ''
            },
        }).then(function (response: AxiosResponse) {
            // attachmentFile(dispatch, getState);
            getMessage(dispatch, getState);

            const message = '';
            dispatch({ type: STORE_MESSAGE_SUPPORT_PAGE_MESSAGE, message } as AnyAction);

        }).catch(function (error: AxiosError) {

            // ==> console.error(error.message);
        });
    }
};

export const downloadAttachment = (msgAttachment: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const filePath = msgAttachment;
        await axios({
            method: 'get',
            url: `${getState().environment.API_URL}getDownloadUrl?fullPath=${filePath}`,
        }).then(function (response: AxiosResponse) {
            // attachfilename
            window.open(response.data.signedUrl);
        }).catch(function (error: AxiosResponse) {
            // ==> console.error(error);
        });
    };
};

export const submitSupportFeedback = (payload: SupportRequestPayload) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const sessionid = getState().user.userDetails.s || '';

        dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}submit/support-feedback`,
            data: payload,
            headers: {
                sessionid: sessionid || ''
            }
        }).then(async function (response: AxiosResponse) {
            dispatch(push('/app/supportchat'));
            dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

        }).catch(function (error: AxiosResponse) {
            getMessage(dispatch, getState);
            dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
            dispatch(push('/app/supportchat'));
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/supportPageAction.ts